// Review-surface consolidation §2 — the per-row review page is now a thin
// deep-link target. The canonical review surface is the slide-over opened
// from the Review Queue, so this route just forwards to the queue with the
// submission auto-opened (?submissionId). Email + bookmark links to
// /collection/staging/:id keep working; the queue renders the same panel.

import { Navigate, useParams } from "react-router-dom";

export function CollectionStagingReviewPage() {
  const { id = "" } = useParams<{ id: string }>();
  return (
    <Navigate
      to={`/collection/staging?submissionId=${encodeURIComponent(id)}`}
      replace
    />
  );
}
